// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-wrapper {\n  background-color: #fff;\n  margin: 10px;\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
